import { useQuery } from "@tanstack/react-query"
import { getCategories } from "../actions/getCategories";

export const useCategoriesQuery = () => {

    const categoriesQuery = useQuery({
        queryKey: ["categories"],
        queryFn: () => getCategories(),
        staleTime: 1000 * 60 * 5
    });

    return categoriesQuery
}